import { Button } from "reactstrap";

import styles from "Pages/Setup/Connect/Onboarding.module.css";

interface Props {
    goTo: (view: string) => void;
}

export default function SpectrumConnect({ goTo }: Props) {
    return (
        <div className={styles.panel}>
            <div className={styles.phead}>
                <div className={`${styles.logo} ${styles.logoSpectrum}`}>SP</div>
                <div>
                    <div className={styles.pheadName}>Spectrum</div>
                    <div className={styles.pheadSub}>
                        Trimble Viewpoint Spectrum setup is in progress
                    </div>
                </div>
                <span className={`${styles.pill} ${styles.pillTodo}`}>
                    <span className={styles.dot} /> Coming soon
                </span>
            </div>

            <div className={styles.tabs}>
                <button className={`${styles.tab} ${styles.tabActive}`}>
                    Connect
                </button>
                <button className={styles.tab} onClick={() => goTo("secondarytest")}>
                    Test Connection
                </button>
            </div>

            <div className={styles.sec}>
                <h4>Spectrum onboarding placeholder</h4>
                <p className={styles.hint}>
                    Ramp + Spectrum support is now separated into dedicated
                    components, but Spectrum connection steps are still being
                    finalized.
                </p>
                <p className={styles.hint} style={{ marginBottom: 0 }}>
                    This panel is intentionally a placeholder so Spectrum
                    fields and setup guidance can be added without changing the
                    Ramp + CMiC or Ramp + MRI flows.
                </p>
            </div>

            <div className={styles.footbar}>
                <Button color="link" onClick={() => goTo("ramp")}>← Back to Ramp</Button>
                <span className={styles.saveState}>Spectrum setup steps coming soon.</span>
            </div>
        </div>
    );
}